import { DocumentationFormConfig } from '../../common/types/documentation';
import { Setting } from '../../common/types/settings';
import fbFormConfig from '../fbForm/fbFormConfig';
import counselingCenterFormConfig from '../fhbfForm/counselingCenterForm/counselingCenterFormConfig';
import interventionCenterFormConfig from '../fhbfForm/interventionCenterForm/interventionCenterFormConfig';

const reactAppVersion = process.env.REACT_APP_VERSION;

const getFormConfig = (location: string, groups: Setting[]): DocumentationFormConfig[] => {
  if (reactAppVersion === 'fb') {
    return fbFormConfig(groups);
  }
  if (reactAppVersion === 'fhbf' && location.includes('interventionsstelle')) {
    return interventionCenterFormConfig();
  }
  if (reactAppVersion === 'fhbf' && location.includes('fachberatungsstelle')) {
    return counselingCenterFormConfig(groups);
  }
  return [];
};

export default getFormConfig;
